import { useEffect, useRef, useState } from "react";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import { PRODUCTS_API, PRODUCTSIZE_API, PRODUCT_COST } from "../../../../../Utilities/APIs/APIs";
import CRUDButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/CRUDButton";
import { useNavigate } from "react-router-dom";
import { RiImage2Line, RiSearchLine } from "react-icons/ri";
import Pagination from "../../../../Partials/Elements/pagination/Pagination";

function StockReport() {
  const [products, setProducts] = useState([]);
  const [productSizes, setProductSizes] = useState({});
  const screenHeaerRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight);
  }, [screenHeaerRef]);

  const [toggleFetch, setToggleFetch] = useState(false);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [limit] = useState(40);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();
  const [unitCosts, setUnitCosts] = useState({});

  useEffect(() => {
    async function fetchAndSetProducts() {
      const res = await axiosInstance.get(
        `${PRODUCTS_API}?search=${search}&page=${currentPage}&limit=${limit}`
      );
      const fetchedProducts = res?.data?.products || [];
      
      // Calculate unit cost, total cost, and total price
      const updatedProducts = fetchedProducts.map((product) => {
        const unitCost = product.unitCost || 0;
        const totalCost = unitCost * (product.quantity || 0);
        const totalPrice = (product.price || 0) * (product.quantity || 0);
  
        return {
          ...product,
          unitCost,
          totalCost,
          totalPrice,
        };
      });
  
      setProducts(updatedProducts);
      setTotalItems(res?.data?.totalItems);
  
      // Fetch product sizes for each product
      updatedProducts.forEach(async (product) => {
        const sizeRes = await axiosInstance.get(
          PRODUCTSIZE_API + 'getProductSizesByProduct/' + product._id
        );
        setProductSizes((prevState) => ({
          ...prevState,
          [product._id]: sizeRes?.data || [],
        }));
      

      const costRes = await axiosInstance.get(
        PRODUCT_COST + 'getManageCostByProduct/' + product._id
      );
      const unitCost = costRes?.data?.length > 0 ? costRes.data[0].unitCost : 0;
      
      setUnitCosts((prevState) => ({
        ...prevState,
        [product._id]: unitCost,
      }));

    });
    }
  
    fetchAndSetProducts();
  }, [toggleFetch, axiosInstance, search, currentPage]);

  const handleSearchInput = (value) => {
    const timeoutId = setTimeout(() => {
      setSearch(value);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  };

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <h1 className="screen_heading">Products ({totalItems} in total)</h1>
        <div>
          <input
            value={searchInput}
            onChange={(e) => {
              handleSearchInput(e.target.value);
              setSearchInput(e.target.value);
            }}
            className="input_field"
            placeholder="Search"
            style={{ width: "400px" }}
          />
          <RiSearchLine
            style={{
              width: "30px",
              height: "30px",
              marginLeft: "-50px",
              color: "var(--white-2)",
            }}
          />
        </div>
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th="SKU" />
          <CRUDth th="Name" />
          <CRUDth th="Unit Cost" />
          <CRUDth th="Total Cost" />
          <CRUDth th="Price" />
          <CRUDth th="Total Price" />
          <CRUDth th="Total Quantity" />
        </CRUDTableHeader>
        <tbody>
          {products?.length > 0 &&
            products?.map((product) => (
              product.isVisible && (
                <CRUDTableRow key={product._id}>
                  <ShortTextCell text={product.squId} />
                  <ShortTextCell text={product.name} />
                  <ShortTextCell text={unitCosts[product._id] || product.unitCost || '0'} />
                  <ShortTextCell text={product.totalCost.toFixed(2)} />
                  <ShortTextCell text={product.price.toFixed(2)} />
                  <ShortTextCell text={product.totalPrice.toFixed(2)} />
                  <ShortTextCell text={product.quantity} />
                </CRUDTableRow>
              )
            ))}
        </tbody>
        <Pagination
          items={products}
          totalItems={totalItems}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </CRUDTable>
    </>
  );
}

export default StockReport;
